<template>
  <NuxtLayout>
    <ErrorHandler/> 
  </NuxtLayout>
</template>
